import useDoRecentOrder from '@activities/MainActivity/components/RecentOrders/hooks/useDoRecentOrder';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import PinMapLine from '@icons/pin/PinMapLine';
import { RecentOrderRow } from '@models/order';
import { useFlow } from '@stackflow/react';

interface Props {
    recentOrder: RecentOrderRow;
}

function RecentOrder({ recentOrder }:Props) {
    const { push } = useFlow();
    const handleClick = useDoRecentOrder(recentOrder);
    const {
        orderNo, orderName, shopName, orderItems, paymentAmount,
    } = recentOrder;
    const optionSummary = orderItems?.[0]?.options
        .map((option) => `${option.optionName}(${option.qty}개)`)
        .join(', ');
    const thumbnailImage = orderItems?.[0]?.thumbNailImageUrl;
    return (
        <Container onClick={handleClick} >
            <Thumbnail src={thumbnailImage}
                alt='메뉴 이미지'
                width={80}
                height={80}/>
            <Contents spacing={1.5}>
                <NameText>{orderName}</NameText>
                <Column spacing={0.5}>
                    <Row spacing={0.5}>
                        <PinMapLine color={colors.gray6} size={16} />
                        <ShopText color={colors.gray6}>
                            {shopName}
                        </ShopText>
                    </Row>
                    <OptionsText>
                        {optionSummary}
                    </OptionsText>
                    <Row>
                        <Text size='title'
                            color={colors.gray8}
                            fontWeight='bold'>
                            {paymentAmount.toLocaleString()}
                        </Text>
                        <PriceUnitText color={colors.gray8} >
                            원
                        </PriceUnitText>
                    </Row>
                </Column>
            </Contents>
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    background-color: var(--color-white);
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    padding: 12px 0 12px 12px;
    border-radius: 8px;
    column-gap: 6px;
    width: 204px;
    min-width: 204px;
    scroll-snap-align: start;
    scroll-snap-stop: always;
`;

const Thumbnail = styled(Image)`
    height: 62px;
    width: 62px;
`;

const Contents = styled(Column)`
    flex: 1;
    overflow: hidden;
`;

const NameText = styled(Text)`
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
`;

const ShopText = styled(Text)`
    font-size: 10px;
`;

const OptionsText = styled(Text)`
    color: var(--color-gray6);
    font-size: 10px;
    line-height: 13px;
`;

const PriceUnitText = styled(Text)`
    vertical-align: middle;
`;

export default RecentOrder;
